export default __webpack_public_path__ + "static/media/apps_openapi.8403a5a1.yaml";